import { Descope } from '@descope/react-sdk';
import { Box, Dialog, DialogContent, useTheme } from '@mui/material';
import React from 'react';
import { ITheme } from 'types/theme';

interface IPromoteBiometricsDialogProps {
	onSuccess: () => void;
	onError: (e: string | Event) => void;
	onCancel: () => void;
}

const PromoteBiometricsDialog = ({
	onSuccess,
	onError,
	onCancel
}: IPromoteBiometricsDialogProps) => {
	const theme = useTheme<ITheme>();
	return (
		<Dialog
			open
			maxWidth="xs"
			disableRestoreFocus
			onClose={onCancel}
			PaperProps={{ sx: { minHeight: 150 } }}
			data-testid="promote-biometrics-dialog"
		>
			<DialogContent sx={{ p: 0 }}>
				<Box data-testid="promote-biometrics-container">
					<Descope
						flowId="promote-biometrics"
						onSuccess={onSuccess}
						onError={onError}
						theme={theme.palette.mode}
					/>
				</Box>
			</DialogContent>
		</Dialog>
	);
};

export default PromoteBiometricsDialog;
